import getMarkdocModel from "../../getters/markdocModel";

export const bpmn = getMarkdocModel("Bpmn");
